import { Card, CardBody } from "reactstrap";
import { Spin } from "antd";
import TableContainerMin from "../../../../Components/Common/TableContainerMin";
import { formatState, getStateColor } from "../../../../Components/Common/FormatDate/formatStatus";

const IntervenantDemande = ({ intervenants, isLoading, isError, error }) => {

    const columns = [
        {
            Header: "Nom",
            accessor: "intervenantName",
            Cell: ({ row }) => (
                <div>{row.original.intervenantName || "-"}</div>
            ),
        },
        { 
            Header: "Téléphone",
            accessor: "intervenantPhone",
            Cell: ({ row }) => (
                <div>{row.original.intervenantPhone || "-"}</div>
            ),
            filterable: false 
        },  
        {
            Header: "Adresse email",
            accessor: "intervenantEmail",
            Cell: ({ row }) => (
                <div>{row.original.intervenantEmail || "-"}</div>
            ),
            filterable: false,
        },                  
        {
            Header: "Statut",
            accessor: "status",
            Cell: ({ value }) => (
              <span
                className={`badge bg-${getStateColor(value)}-subtle text-${getStateColor(value)}`}
              >
                {formatState(value)}
              </span>
            ),
            filterable: false,
        },
        {
            Header: "Matériel",
            accessor: "materialName",
            Cell: ({ row }) => (
                <div>{row.original.materialName || "-"}</div>
            ),
        },
    ];

    return (
        <Card>
            <CardBody className="pt-0">
                <h6 className="mb-0 p-2">Liste des intervenants</h6>

                {intervenants && intervenants.length > 0 ? (
                    <>
                        <TableContainerMin
                            columns={columns}
                            data={intervenants}
                            isGlobalFilter={true}
                            customPageSize={5}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                        />

                        {isLoading && !isError && (
                            <div className="text-center">
                                Chargement, Merci de patienter ... <Spin />
                            </div>
                        )}

                        {intervenants.length === 0 && !isLoading && (
                            <div className="text-center">
                                Aucun intervenant à afficher pour le moment.
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center mt-4 mb-4">
                        Aucun intervenant à afficher pour le moment.
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default IntervenantDemande;
